/**
 * What the product page says about stock.
 * - Tracked stock (not "keep selling"): sold out at 0 or below; "Only N left" at 1–5; otherwise "N in stock".
 * - "Keep selling when out of stock": always orderable, and never a number or "only N left" — the count means nothing
 *   there (it is often 0 or negative), and claiming scarcity that isn't real would be false urgency.
 */
export const LOW_STOCK_LIMIT = 5;
const KEEP_SELLING_MAX_QTY = 10;

export const stockStatus = (stockQty, continueSelling) => {
  const qty = Number(stockQty) || 0;
  if (continueSelling) {
    return { isOOS: false, isLowStock: false, label: 'In stock', maxQty: Math.max(qty, KEEP_SELLING_MAX_QTY) };
  }
  if (qty <= 0) return { isOOS: true, isLowStock: false, label: 'Sold out', maxQty: 0 };
  if (qty <= LOW_STOCK_LIMIT) return { isOOS: false, isLowStock: true, label: `Only ${qty} left`, maxQty: qty };
  return { isOOS: false, isLowStock: false, label: `${qty} in stock`, maxQty: qty };
};
